/* eslint-disable react/jsx-props-no-spreading */

import React, { useEffect, useState } from 'react';
import { Affix, Button, Card, Divider, message, Row } from 'antd';

import { connect, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { getCmsLanguagesAction } from '../../../actions/AppCms/CmsLanguageActions';
import {
  getAppSettingsAction,
  saveAppSettingsAction,
} from '../../../actions/AppCms/AppSettingsActions';
import CustomAddNewPageContent from '../../../components/Content/CustomAddNewPageContent';
import General from './tabs/General';
import Language from './tabs/Language';
import Authorized from '../../../components/Authorization/Authorized';
import AuditTrail from '../../../components/AuditTrail/AuditTrail';

const AppSettings = ({ form }) => {
  const dispatch = useDispatch();
  const [id, setId] = useState(0);

  const { cmsLanguageList, appSettings } = useSelector(store => ({
    cmsLanguageList: store.cmsLanguageReducer.cmsLanguageList,
    appSettings: store.appSettingsReducer.appSettings,
  }));

  useEffect(() => {
    dispatch(getCmsLanguagesAction());
    dispatch(getAppSettingsAction());
  }, []);

  useEffect(() => {
    if (appSettings && appSettings.id) {
      setId(appSettings.id);
    }
  }, appSettings);

  const handleSubmit = e => {
    if (e) {
      e.preventDefault();
    }

    form.validateFieldsAndScroll((err, fieldsValue) => {
      if (!err) {
        const content = [];
        cmsLanguageList.map(item => {
          if (fieldsValue['description-' + item.isoLanguage.code]) {
            content.push({
              description: fieldsValue['description-' + item.isoLanguage.code],
              language: item.isoLanguage.code,
            });
          }
          return null;
        });

        const values = {
          content,
          image: fieldsValue.image[0],
          icon: fieldsValue.icon[0],
          aboutImage: fieldsValue.aboutImage[0],
          websiteLink: fieldsValue.websiteLink,
          mainColour: fieldsValue.mainColour.hex
            ? fieldsValue.mainColour.hex
            : fieldsValue.mainColour,
          // secondaryColour: fieldsValue.secondaryColour.hex
          //   ? fieldsValue.secondaryColour.hex
          //   : fieldsValue.secondaryColour,
          previewModeOn: fieldsValue.previewModeOn,
        };

        

        dispatch(saveAppSettingsAction(values)).then(() => {
          message.success('App Settings saved successfully');
        });
      }
    });
  };

  const getReportData = (appSettingsData, lang) => {
    const result =
      appSettingsData &&
      appSettingsData.content.filter(obj => {
        return obj.language === lang;
      });
    return result ? result[0] : result;
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 },
      lg: { span: 10 },
      xl: { span: 10 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 },
      lg: { span: 12 },
      xl: { span: 12 },
    },
  };

  return (
    <>
      <CustomAddNewPageContent title="App Settings" subTitle="App Settings">
        <Form {...formItemLayout} onSubmit={handleSubmit}>
          <Card
            title="GENERAL"
            bordered={false}
            extra={
              <Affix offsetTop={10}>
                <Authorized asset="appcms" operation="write">
                  <Button type="primary" htmlType="submit">
                    Save
                  </Button>
                </Authorized>
              </Affix>
            }
          >
            <General
              form={form}
              reportData={appSettings ? appSettings.data : null}
              submit={handleSubmit}
            />
          </Card>
          {cmsLanguageList.map(item => (
            <Card
              key={item.isoLanguage.code}
              title={
                item.isoLanguage.code +
                (item.defaultInMobileApp ? ' (Default)' : '')
              }
            >
              <Language
                form={form}
                langCode={item.isoLanguage.code}
                language={item}
                reportData={getReportData(
                  appSettings ? appSettings.data : null,
                  item.isoLanguage.code,
                )}
                defaultLang={item.defaultInMobileApp}
              />
            </Card>
          ))}
          <Divider />
          <Row type="flex" justify="center">
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Row>
          <Divider />
          <AuditTrail objectId={id} objectType="app settings" />
        </Form>
      </CustomAddNewPageContent>
    </>
  );
};

AppSettings.propTypes = {
  form: PropTypes.object,
  getCmsLanguagesAction: PropTypes.func,
  saveAppSettingsAction: PropTypes.func,
  getAppSettingsAction: PropTypes.func,
  appSettings: PropTypes.object,
  cmsLanguageList: PropTypes.array,
};

const WrappedAppSettingsForm = Form.create({
  name: 'WrappedAppSettings',
})(AppSettings);

function mapStateToProps({ cmsLanguageReducer, appSettingsReducer }) {
  const { cmsLanguageList } = cmsLanguageReducer;
  const { appSettings } = appSettingsReducer;
  return { cmsLanguageList, appSettings };
}

const WrappedAppSettings = connect(mapStateToProps, {
  getCmsLanguagesAction,
  saveAppSettingsAction,
  getAppSettingsAction,
})(WrappedAppSettingsForm);

export default WrappedAppSettings;
